const checkedCount = (counts, items) =>
	items.reduce((total, item) => total + (counts[item.id] || 0), 0);

const UNKNOWN_ITEM_WARNING = 'Delete this item? People who checked it will lose that check.';
const CHECKED_SECTION_WARNING =
	'People checked items in this section. Deleting removes them from the app and the CSV.';
const UNKNOWN_SECTION_WARNING =
	'Delete this section? People who checked its items will lose those checks.';

export const itemDeleteWarning = (count, saved) => {
	if (count === null) return saved && UNKNOWN_ITEM_WARNING;
	const people = count === 1 ? 'person' : 'people';
	return (
		count > 0 && `${count} ${people} checked this. Deleting removes it from the app and the CSV.`
	);
};

export const sectionDeleteWarning = (section, counts, savedItemIDs) => {
	const { items } = section;
	if (counts && checkedCount(counts, items) > 0) return CHECKED_SECTION_WARNING;
	if (!counts && items.some(item => savedItemIDs.has(item.id))) return UNKNOWN_SECTION_WARNING;
	return (
		items.length > 0 &&
		`Delete this section and its ${items.length} ${items.length === 1 ? 'item' : 'items'}?`
	);
};
